// Generated by scripts/build-ui-icons.mjs.
export { Recycle as default } from "../ui/glyphs-6";
